import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import PopconfirmTitle from './PopconfirmTitle';
import { EngineDeactivationReasonEnum } from '@/constants/engine-deactivation-reason';
import { DefaultSetpointsOption } from '@/constants/enums';

interface DeactivateDynamicControllerModalProps {
  isVisible: boolean;
  onOk: () => void;
  onCancel: () => void;
  isLoading: boolean;
  isProactiveEngineStateActivated: boolean;
  popconfirmTitleRef: React.RefObject<{ resetControls: () => void }>;
  setCommentRef: (ref: EngineDeactivationReasonEnum | null) => void;
  setComment: (comment: string | null) => void;
  setIsError: (isError: boolean) => void;
  defaultSetpointsOption?: DefaultSetpointsOption;
  isError: boolean;
}

export const DeactivateDynamicControllerModal: React.FC<DeactivateDynamicControllerModalProps> = ({
  isVisible,
  onOk,
  onCancel,
  isLoading,
  isProactiveEngineStateActivated,
  popconfirmTitleRef,
  setCommentRef,
  setComment,
  setIsError,
  defaultSetpointsOption,
  isError,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('confirmDeactivationTitle')}
      open={isVisible}
      onOk={onOk}
      okText={t('confirmDeactivationButtonText')}
      maskClosable={false}
      destroyOnClose={true}
      onCancel={onCancel}
      centered
      width={550}
      maskTransitionName=""
      transitionName=""
    >
      <PopconfirmTitle
        ref={popconfirmTitleRef}
        isProactiveEngineStateActivated={isProactiveEngineStateActivated}
        isLoading={isLoading}
        setCommentRef={setCommentRef}
        setComment={setComment}
        setIsError={setIsError}
        defaultSetpointsOption={defaultSetpointsOption}
        isError={isError}
      />
    </Modal>
  );
};
